import React from 'react'

const Authenticity = () => {
    return(
        <div>
            track page
        </div>
    )
}

export default Authenticity